import { createReducer } from '@reduxjs/toolkit';
import { persistReducer, purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';
import t from '@/store/types';

export const defaultTableQuery = {
  pageSize: 20,
  pageIndex: 0,
  filterRoles: [],
  viewSlug: null,
};

const initialState = {
  tableState: defaultTableQuery,
  selectedRows: [],
};

const STORAGE_KEY = 'leyona:manualJournals';

const CONFIG = {
  key: STORAGE_KEY,
  whitelist: [],
  storage,
};

const reducerInstance = createReducer(initialState, (builder) => {
  Object.entries(
    createTableStateReducers('MANUAL_JOURNALS', defaultTableQuery),
  ).forEach(([actionType, reducer]) => {
    builder.addCase(actionType, reducer);
  });

  builder.addCase(`MANUAL_JOURNALS/SET_SELECTED_ROWS`, (state, action: any) => {
    state.selectedRows = action.payload;
  });

  builder.addCase(t.RESET, () => {
    purgeStoredState(CONFIG);
  });
});

export default persistReducer(CONFIG, reducerInstance);
